export default {
  AU_COPYRIGHT: '版权所有@2015-2021',
  AU_DFOCUS: 'DFocus 耘申信息科技(上海)有限公司',
  AU_COMPANY_WEBSITE: '公司官网',
  AU_ABOUT_US: '关于我们',
  ABOUT_US_SEETING: '关于我们',
  LOGIN_PAGE_SEETING: '登录首页'
}
